import { createContext } from 'react';

import { MenuBarContextProps } from '../interfaces/contexts';

export const MenuBarContext = createContext<MenuBarContextProps>({
  menuBarHidden: false,
  setMenuBarHidden: () => false
});
